import { getTimezoneOffset } from '@prophecy/utils/date';
import { getCronDisplayText } from 'frontend/core/src/common/utils/cron';

/** Formats an IANA timezone (e.g. "Asia/Kolkata") the same way TimezonePicker's own option labels do. */
export const getTimezoneLabel = (timeZone?: string): string | undefined =>
  timeZone ? `(GMT${getTimezoneOffset(timeZone)}) ${timeZone.replace(/_/g, ' ')}` : undefined;

/** Human-readable schedule label (e.g. "Every 2 hours from 12:00 AM", "Daily at 02:00 AM",
 * "Weekly on Monday, Wednesday at 02:00 AM") shown in the read-only Knowledge Graph Indexer summary. */
export const getKgScheduleDisplay = getCronDisplayText;
